export default "__VITE_ASSET__DKmsmu18__"